import styled, { css, keyframes } from "styled-components";
import { MEDIA_SCREEN } from "../../utils/Enum";
import { hexToRgba } from "../HexToRGBA";

/* Balance Cards */
export const BalanceDisplayContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 1rem;
`;

export const BalanceCard = styled.div`
  padding: 1rem;
  width: 100%;
  background-color: #1f2937; /* gray-800 */
  border-radius: 0.5rem;
  box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  color: ${(props) => (props?.tip ? "#10b981" : "#6366f1;")};
  border: ${(props) =>
    props?.tip
      ? "1px solid rgba(16, 185, 129, 0.4)"
      : "1px solid rgba(79, 70, 229, 0.4)"};
  @media screen and (min-width: ${MEDIA_SCREEN.LAPTOPS}px) {
    flex-direction: row;
    
  }
`;

export const BalanceInfo = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;

  @media (min-width: 768px) {
    margin-bottom: 0;
  }
`;

export const BalanceLabel = styled.span`
  color: #ffffff;
  font-weight: 500;
`;

export const BalanceValueContainer = styled.div`
  text-align: right;
`;

export const BalanceXRP = styled.p`
  font-size: 1.5rem;
  font-family: "Space Mono", monospace; /* Monospace font for currency */
  font-weight: 700;
  white-space: nowrap;
`;

export const BalanceConverted = styled.p`
  font-size: 0.875rem;
  color: #9ca3af; /* gray-400 */
`;


export const RefreshIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    style={{ width: "20px", height: "20px" }}
  >
    <path
      fillRule="evenodd"
      d="M4.755 10.059a7.5 7.5 0 0112.548-3.364l1.903 1.903h-3.183a.75.75 0 100 1.5h4.992a.75.75 0 00.75-.75V4.356a.75.75 0 00-1.5 0v3.18l-1.903-1.902a9 9 0 00-15.122 3.321v.5A.75.75 0 004.755 10.06zm14.49 4.241a7.5 7.5 0 01-12.548 3.364l-1.903-1.903h3.183a.75.75 0 000-1.5H2.984a.75.75 0 00-.75.75v4.992a.75.75 0 001.5 0v-3.18l1.903 1.902a9 9 0 0015.122-3.321v-.5a.75.75 0 00-.75-.75z"
      clipRule="evenodd"
    />
  </svg>
);

export const ClaimIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    style={{ width: "20px", height: "20px" }}
  >
    <path
      fillRule="evenodd"
      d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zM12.75 6a.75.75 0 00-1.5 0v6c0 .414.336.75.75.75h4.5a.75.75 0 000-1.5h-3.75V6z"
      clipRule="evenodd"
    />
  </svg>
);

export const CancelIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    style={{ width: "20px", height: "20px" }}
  >
    <path
      fillRule="evenodd"
      d="M5.47 5.47a.75.75 0 011.06 0L12 10.94l5.47-5.47a.75.75 0 111.06 1.06L13.06 12l5.47 5.47a.75.75 0 11-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 01-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 010-1.06z"
      clipRule="evenodd"
    />
  </svg>
);

export const ChevronDownIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
    style={{ width: "16px", height: "16px", marginLeft: "0.5rem" }}
  >
    <path
      fillRule="evenodd"
      d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.25 4.25a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.06z"
      clipRule="evenodd"
    />
  </svg>
);
export const FundsButtonWrapper = styled.div`
display: flex;
flex-direction: row;
justify-content: space-evenly;
padding: 2%;
align-items: center;
`
export const FundsButton = styled.div`
display: flex;
  margin-left: 2%;
  margin-right: 1%;
  font-size: 0.8rem;
  width: 120px;
  color: ${props => props?.active ? props.theme.secondaryBg : '#9CA3AF'};
  cursor: pointer;
  border-radius: 7px;
  justify-content: center;
  outline: none;
  background-color: ${props => props?.active ?  hexToRgba(props.theme.accentColor,0.8) : hexToRgba(props.theme.secondaryColor,0.1)};
  padding: 0.5rem 1rem;
 &:hover {
        transition: all 0.2s ease-in-out;
          background-color: ${props => props?.active ? props.theme.secondaryColor : props.theme.accentColor };

        color: ${(props) => (props.active ? props.theme.secondaryBg : props.theme.accentColor)};
        border: ${(props) => props.outline ? '1px solid' : 'none'};

    }
  @media screen and (max-width: ${MEDIA_SCREEN.TABLETS}px) {
    font-size: 0.8rem;
    padding: 0.4rem 0.8rem;
  }

`



// Animations
const slideUp = keyframes`
  from { opacity: 0; transform: translateY(12px); }
  to { opacity: 1; transform: translateY(0); }
`;

const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
`;

// Containers & Layout
export const SelectorContainer = styled.div`
  min-height: 100vh;
  color: ${props => props.theme.secondaryColor};
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  user-select: none;
  background-color: ${props => props.theme?.mainBg};

  @media (min-width: 768px) {
    padding: 48px;
  }
`;

export const ToastWrapper = styled.div`
  position: fixed;
  top: 24px;
  right: 24px;
  z-index: 50;
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 384px;
  width: 100%;
  pointer-events: none;
`;

export const ToastAlert = styled.div`
  padding: 16px;
  border-radius: 12px;
  border: 1px solid;
  background-color: rgba(19, 26, 48, 0.95);
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
  pointer-events: auto;
  transition: all 0.3s ease;
  transform: translateY(0);
  animation: ${slideUp} 0.3s ease-out forwards;

  ${props => props.type === 'success' && css`
    border-color: #05c483;
    color: #05c483;
  `}
  ${props => props.type === 'warning' && css`
    border-color: #ffb74d;
    color: #ffb74d;
  `}
  ${props => props.type === 'error' && css`
    border-color: #ff4d4d;
    color: #ff4d4d;
  `}
`;

export const MainGrid = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;
  align-items: stretch;
  animation: ${slideUp} 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards;
`;

export const LeftColumn = styled.div`
  background-color: ${props => props.theme.mainBg};
  border: 1px solid ${props => props.theme.mainColor};
  border-radius: 24px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 24px;

  @media (min-width: 768px) {
    padding: 32px;
  }
  @media (min-width: 1024px) {
    grid-column: span 6 / span 6;
  }
`;

export const PortalBadge = styled.span`
  font-size: 10px;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 0.15em;
  padding: 4px 12px;
  border-radius: 9999px;
  background-color: rgba(255, 105, 120, 0.1);
  color: ${props => props.theme.secondaryColor};
  border: 1px solid rgba(255, 105, 120, 0.2);
  display: inline-block;
  align-self: flex-start;
`;

export const ColumnTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 900;
  color: ${props => props.theme.secondaryBg};
  line-height: 1.25;
  margin: 16px 0 8px 0;
`;

export const ColumnDesc = styled.p`
  font-size: 0.75rem;
  color: ${props => props.theme.accentColor};
  line-height: 1.625;
  margin: 0;
`;

export const NetworkList = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
`;

export const NetworkCard = styled.div`
  padding: 16px;
  border-radius: 12px;
  border: 1px solid;
  display: flex;
  align-items: center;
  gap: 20px;
  transition: all 0.2s ease;
  cursor: pointer;

  background-color: ${props => props.active ? 'rgba(26, 35, 61, 0.45)' : 'rgba(15, 23, 42, 0.3)'};
  border-color: ${props => props.active ? props.theme.secondaryColor : props.theme.mainColor};

  ${props => props.disabled && css`
    opacity: 0.4;
    border-color: rgba(30, 41, 59, 0.5);
    cursor: not-allowed;
  `}

  &:hover {
    border-color: ${props => props.active ?  props.theme.secondaryColor : '#334155'};
  }
`;

export const NetworkIconBox = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid;
  flex-shrink: 0;
`;

export const NetworkMeta = styled.div`
  flex: 1;
`;

export const NetworkHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const NetworkName = styled.h4`
  font-size: 0.875rem;
  font-weight: 800;
  color: ${props => props.theme.secondaryBg};
  margin: 0;
`;

export const NetworkTicker = styled.span`
  font-size: 10px;
  font-weight: 900;
  text-transform: uppercase;
  color: ${props => props.theme.accentColor};
  letter-spacing: 0.05em;
`;

export const NetworkDescText = styled.p`
  font-size: 11px;
  color: ${props => props.theme.accentColor};
  margin-top: 4px;
  margin-bottom: 0;
  line-height: 1.375;
`;

export const RightColumn = styled.div`
  background-color: ${props => props.theme.mainBg};
  border: 1px solid ${props => props.theme.mainColor};
  border-radius: 24px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 24px;

  @media (min-width: 1024px) {
    grid-column: span 6 / span 6;
  }
`;

export const CardSectionTitle = styled.h3`
  font-size: 0.875rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: ${props => props.theme.accentColor};
  border-bottom: 1px solid ${props => props.theme.mainColor};
  padding-bottom: 12px;
  margin: 0;
`;

export const FormLabel = styled.label`
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  color: ${props => props.theme.accentColor};
  letter-spacing: 0.05em;
  display: block;
  margin-bottom: 6px;
`;

export const AmountGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
`;

export const AmountBtn = styled.button`
  padding: 10px;
  border-radius: 12px;
  font-weight: 700;
  font-size: 0.75rem;
  border: 1px solid;
  transition: all 0.2s ease;
  cursor: pointer;

  background-color: ${props => props.active ?  props.theme.secondaryColor :  props.theme.mainBg};
  color: ${props => props.active ? '#080c16' :  props.theme.accentColor};
  border-color: ${props => props.active ?  props.theme.secondaryColor :  props.theme.mainColor};

  &:hover {
    background-color: ${props => props.active ?  props.theme.secondaryColor :  props.theme.mainColor};
  }
`;

export const QRPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 16px;
  border-radius: 12px;
  border: 1px solid ${props => props.theme.mainColor};
  background-color: ${props => props.theme.mainBg};

  @media (min-width: 640px) {
    flex-direction: row;
    align-items: center;
  }
`;

export const QRImageBox = styled.div`
  width: 128px;
  height: 128px;
  background-color: ${props => props.theme.secondaryBg};
  border-radius: 8px;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: inset 0 2px 4px 0 rgba(0,0,0,0.06);
`;

export const QRDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const QRTitle = styled.h4`
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: ${props => props.theme.secondaryBg};
  margin: 0;
`;

export const QRDescText = styled.p`
  font-size: 11px;
  color: ${props => props.theme.accentColor};
  line-height: 1.5;
  margin: 0;
`;

export const URIDisplay = styled.div`
  font-size: 10px;
  font-family: monospace;
  color: ${props => props.theme.accentColor};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 200px;
  user-select: all;
`;

export const ManualSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  border-radius: 12px;
  border: 1px solid ${props => props.theme.mainColor};
  background-color: rgba(19, 26, 48, 0.5);
`;

export const CopyGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const MiniLabel = styled.span`
  font-size: 9px;
  font-weight: 900;
  text-transform: uppercase;
  color: ${props => props.warning ? '#ffb74d' :  props.theme.accentColor};
`;

export const CopyRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  background-color: ${props => props.theme.mainBg};
  border: 1px solid ${props => props.theme.mainColor};
  padding: 10px;
  border-radius: 8px;
`;

export const MonoText = styled.span`
  font-family: monospace;
  font-size: 0.75rem;
  color: ${props => props.warning ? '#ffb74d' : '#cbd5e1'};
  user-select: all;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const CopyBtn = styled.button`
  padding: 4px 12px;
  border-radius: 4px;
  background-color: ${props => props.theme.mainColor};
  color: #cbd5e1;
  font-size: 10px;
  font-weight: 700;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: #334155;
    color: ${props => props.theme.secondaryBg};
  }
  &:active {
    transform: scale(0.95);
  }
`;

export const RatesCard = styled.div`
  padding: 16px;
  border-radius: 12px;
  border: 1px solid ${props => props.theme.mainColor};
  background-color: ${props => props.theme.mainBg};
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const RatesRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.75rem;
`;

export const RatesLabel = styled.span`
  color: ${props => props.theme.accentColor};
`;

export const RatesValue = styled.span`
  font-family: monospace;
  font-weight: 700;
  color: ${props => props.color ||  props.theme.secondaryBg};
`;

export const TotalRow = styled.div`
  border-top: 1px dashed ${props => props.theme.mainColor};
  padding-top: 12px;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

export const ActionButton = styled.button`
  width: 100%;
  padding: 14px;
  border-radius: 12px;
  font-weight: 900;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;

  background-color: ${props => props.color ||  props.theme.secondaryColor};
  color: #080c16;

  &:hover {
    filter: brightness(1.05);
  }
  &:active {
    transform: scale(0.98);
  }
`;

export const ProgressBarWrapper = styled.div`
  padding: 16px;
  border-radius: 12px;
  border: 1px solid rgba(30, 41, 59, 0.8);
  background-color: rgba(15, 23, 42, 0.4);
  font-size: 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ProgressHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ProgressStatusTitle = styled.span`
  font-weight: 700;
  color: ${props => props.theme.secondaryColor};
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-size: 10px;
`;

export const ProgressStatusTag = styled.span`
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-size: 9px;
  font-weight: 900;
  color: ${props => props.completed ? '#05c483' : '#ffb74d'};
  animation: ${props => props.completed ? 'none' : css`${pulse} 1.5s infinite`};
`;

export const BarTrack = styled.div`
  width: 100%;
  height: 6px;
  background-color: #131a30;
  border-radius: 9999px;
  overflow: hidden;
`;

export const BarFill = styled.div`
  height: 100%;
  background: linear-gradient(to right, #FF6978, #b266ff);
  transition: all 0.5s ease;
  width: ${props => props.width};
`;

export const ProgressHash = styled.span`
  font-size: 10px;
  color: ${props => props.theme.accentColor};
  display: block;
  font-family: monospace;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-top: 4px;
`;

export const ResetContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const DisclaimerText = styled.span`
  font-size: 9px;
  color: ${props => props.theme.accentColor};
  display: block;
  text-align: center;
  line-height: 1.4;
`;
